import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {BreadcrumbService} from '@catmodules/widgets/breadcrumb/services/breadcrumb.service';
import {ExplorerToolbarComponent} from '@catmodules/widgets/explorer/components/explorer-toolbar/explorer-toolbar.component';
import {ExplorerComponent} from '@catmodules/widgets/explorer/components/explorer/explorer.component';
import {ItemStateComponent} from '@catmodules/widgets/explorer/components/item-state/item-state.component';
import {TreeNodeTemplateLoaderComponent} from '@catmodules/widgets/explorer/components/tree-node-template-loader/tree-node-template-loader.component';
import {TreeNodeComponent} from '@catmodules/widgets/explorer/components/tree-node/tree-node.component';
import {TreeComponent} from '@catmodules/widgets/explorer/components/tree/tree.component';
import {Breadcrumb} from 'primeng/primeng';

const publicComponents = [
];

@NgModule({
  imports: [CommonModule],
  exports: [
    ...publicComponents,
  ],
  declarations: [
    ...publicComponents,
  ],
  entryComponents: [
  ],
  providers: [
    BreadcrumbService,
  ],
})
export class BreadcrumbModule {

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/breadcrumb/breadcrumb.module.ts